import React, { useEffect, useRef, useState } from "react";
import { getUserID } from "../../Utility/service";
import { useNavigate } from "react-router-dom";
import { Checkbox, Dropdown, Menu, Pagination } from "antd";
import {
  IoChatbubbleEllipsesOutline,
  IoGitCompareOutline,
} from "react-icons/io5";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
import "./Assistant.css";
import {
  Button,
  Space,
  Table,
  Tag,
  Modal,
  Tooltip,
  Switch,
  message,
  Spin,
} from "antd";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import axios from "axios";
import { fetchAssistantsCreatedBySuperAdmin } from "../../api/assistant";
import {
  showDeletePublicConfirm,
  handleCheckboxChange,
} from "../../Utility/showModalHelper";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import { CustomSpinner } from "../common/CustomSpinner";
import { personalizeAssistant } from "../../api/personalizeAssistant";
import { LuCopyPlus } from "react-icons/lu";
import { CopyOutlined, SyncOutlined } from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { axiosSecureInstance } from "../../api/axios";
import { BiSolidLock, BiSolidLockOpen } from "react-icons/bi";
import { RiPushpinLine, RiUnpinLine } from "react-icons/ri";
import { generateEmbedCode } from "../../constants/Api_constants";
import ProfileHeader from "../Proflie/ProfileHeader";
import { generateIndustryColorMap } from "../../Utility/industryColorUtils";

const { confirm } = Modal;

const IndustryAssistantList = ({ data }) => {
  const navigate = useNavigate();
  const {
    adminUserAssistants,
    loader,
    handleDeleteAssistant,
    handleUpdateAssistant,
    showEditModalHandler,
    handleFetchUserCreatedAssistants,
    handlePublicAssistantAdd,
    getFavoriteAssistant,
    handleDeletePublicAssistant,
    publicAssistant,
    setPublicAssistant,
    industryAssistant,
    setIndustryAssistant,
    setIsLoading,
    isLoading,
    setLoadMyAssistants,
    updateLoader,
  } = data;

  const [totalCount, setTotalCount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [isAssistantSyncing, setIsAssistantSyncing] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const searchInputRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetchAssistantsCreatedBySuperAdmin(
          currentPage,
          pageSize,
          searchQuery
        );
        setPublicAssistant(response.data);
        setTotalCount(response.meta.total);
      } catch (error) {
        message.error("Failed to fetch assistants");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [searchQuery, currentPage, pageSize]);

  const query =
    typeof searchQuery === "string" ? searchQuery?.toLowerCase() : "";

  // Open selected card in a new page
  const openAssistantNewPage = (assistantId, name) => {
    navigate(`/agents/${assistantId}`);
  };

  const navigateToCustomizationPage = (assistantName, assistantId) => {
    navigate(`/customize-embed-code/${assistantId}`);
  };

  const industryColorMap = generateIndustryColorMap(publicAssistant.map(item => item.industryTypes));

  const getIndustryTagColor = (industryType) => {
    return industryColorMap[industryType || "N/A"] || "default";
  };

  const createActionMenu = (record) => {
    return (
      <Menu>
        <Menu.Item key="chat">
          <span
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onClick={() =>
              openAssistantNewPage(record?.assistant_id, record?.name)
            }
          >
            <IoChatbubbleEllipsesOutline /> Chat with Agent
          </span>
        </Menu.Item>
        <Menu.Item key="delete" danger>
          <span
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
            onClick={async () =>
              await showDeletePublicConfirm(
                record,
                handleDeletePublicAssistant,
                handleUpdateAssistant,
                publicAssistant,
                setPublicAssistant
              )
            }
          >
            <AiOutlineDelete /> Delete
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => {
    setFilteredInfo({});
    if(searchInputRef.current){
      searchInputRef.current.input.setValue("");
    }
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
    if(searchInputRef.current){
      searchInputRef.current.input.setValue("");
    }
  };

  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };

  const uniqueUserNames = [
    ...new Set(publicAssistant.map((item) => item.userInfo)),
  ].map((name) => ({
    text: name,
    value: name,
  }));

  const formatDate = (date, fallbackText = "Invalid Date") => {
    if (!date || isNaN(Date?.parse(date))) {
      return fallbackText;
    }
    return new Date(date)?.toLocaleDateString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const sortDateDescending = (firstRecord, secondRecord, dateField) =>
    new Date(secondRecord[dateField]) - new Date(firstRecord[dateField]);

  const sortBoolean = (firstRecord, secondRecord, field) => {
    return firstRecord[field] === secondRecord[field]
      ? 0
      : firstRecord[field]
        ? -1
        : 1;
  };

  const columns = [
    {
      title: "Agent",
      dataIndex: "name",
      key: "name",
      width: "15%",
      align: "left",
      render: (_, { name, image_url }) => (
        <Space size="middle" className="d-flex align-items-center">
          <div className="assistantImageDiv">
            {image_url ? (
              <img src={image_url} className="customImage" alt="avatar" />
            ) : (
              <BsRobot className="customImage" />
            )}
          </div>
          <div className="ms-2 text-start">{name}</div>
        </Space>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
    },
    {
      title: "Industry",
      dataIndex: "industryTypes",
      key: "industryTypes",
      align: "center",
      width: "12%",
      render: (industryTypes) => (
        <Tag color={getIndustryTagColor(industryTypes)}>
          {industryTypes || "N/A"}
        </Tag>
      ),
      sorter: (a, b) => (a.industryTypes || "").localeCompare(b.industryTypes || ""),
      sortOrder: sortedInfo.columnKey === "industryTypes" ? sortedInfo.order : null,
      filters: [
        ...new Set(publicAssistant.map((item) => item.industryTypes)),
      ].map((type) => ({
        text: type || "N/A",
        value: type || "N/A",
      })),
      filteredValue: filteredInfo.industryTypes || null,
      onFilter: (value, record) => (record.industryTypes || "N/A") === value,
    },
    {
      title: "Model & Tools",
      dataIndex: "model",
      key: "modelAndTools",
      align: "left",
      width: "15%",
      render: (_, { model, tools }) => (
        <Space direction="vertical" size="small">
          <Tag color="blue">
            {Array.isArray(model) && model.length > 0
              ? model[0]
              : model || "No model specified"}
          </Tag>
          <div className="modeltools-column">
            {Array.isArray(tools) && tools.length > 0 ? (
              tools.map((tool, index) => (
                <Tag key={index} color="green">
                  {tool?.name || tool?.type || "Unknown tool"}
                </Tag>
              ))
            ) : (
              <span>No tools enabled</span>
            )}
          </div>
        </Space>
      ),
    },
    {
      title: "Type",
      key: "type",
      align: "center",
      width: "8%",
      render: (_, { tools }) => (
        <Tag color={tools?.length > 0 ? "geekblue" : "purple"}>
          {tools?.length > 0 ? "Agent" : "Assistant"}
        </Tag>
      ),
      filters: [
        { text: "Agent", value: "agent" },
        { text: "Assistant", value: "assistant" },
      ],
      filteredValue: filteredInfo?.type || null,
      onFilter: (value, record) => {
        if (value === "agent") return record.tools?.length > 0;
        if (value === "assistant")
          return !record?.tools || record?.tools?.length === 0;
        return true;
      },
    },
    {
      title: "Creation Date",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: "12%",
      render: (date) => <span>{formatDate(date)}</span>,
      sorter: (firstAssistant, secondAssistant) =>
        sortDateDescending(firstAssistant, secondAssistant, "createdAt"),
      sortOrder: sortedInfo?.columnKey === "createdAt" ? sortedInfo?.order : null,
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "center",
      width: "12%",
      render: (date) => <span>{formatDate(date, "Not updated")}</span>,
      sorter: (firstAssistant, secondAssistant) =>
        sortDateDescending(firstAssistant, secondAssistant, "updatedAt"),
      sortOrder: sortedInfo?.columnKey === "updatedAt" ? sortedInfo?.order : null,
    },
    {
      title: "Action",
      key: "action",
      width: "8%",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={createActionMenu(record)} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
        </Space>
      ),
    },
  ];

  const handleSyncButton = async () => {
    setIsAssistantSyncing(true);
    setIsLoading(true);
    try {
      const isSyncSuccess = await axiosSecureInstance.get(
        "api/assistants/public/sync"
      );
      message.success(isSyncSuccess.data.message);
    } catch (error) {
      message.error("Failed to sync assistants");
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsAssistantSyncing(false);
    }
  };

  return (
    <>
      <div className="mb-1">
        <ProfileHeader
          title="Industry Based Agents"
          subHeading="Explore industry based AI agents created by super admins."
        />

        <div className="searchbox-container">
          <div className="searchbox-wrapper">
            <DebouncedSearchInput
            ref={searchInputRef}
              data={{
                search: searchQuery,
                setSearch: setSearchQuery,
                placeholder: "Search Agent",
              }}
            />
          </div>

          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
          />
        </div>
      </div>

      <Space style={{ marginBottom: 12 }}>
        <Button onClick={clearFilters}>Clear filters</Button>
        <Button onClick={clearAll}>Clear filters and sorters</Button>
      </Space>

      <Table
        loading={isLoading}
        columns={columns}
        dataSource={publicAssistant}
        onChange={handleTableChange}
        scroll={{ y: "50vh" }}
        className={`${isLoading || publicAssistant?.length === 0 ? "mt-3" : ""
          }`}
        pagination={false}
      />
    </>
  );
};

export default IndustryAssistantList;